import React from 'react';
import styles from './Advt.module.css';
import cn from 'classnames';
// import QRcode from '../../assets/images/qrcode.png'
import { iconsSourcesSvg } from '../../helpers/icons';

const Advt = React.memo(({ className, advtInfo }) => {
  return (
    <div className={cn(className)}>
      <div
        className={cn(styles.wrapper, {
          [styles.wrapper__hidden]:
            !advtInfo.label &&
            !advtInfo.number &&
            !advtInfo.socials &&
            !advtInfo.qrCode,
        })}>
        {advtInfo.qrCode && (
          <div className={styles.left}>
            <img src={advtInfo.qrCode} alt="qr-code" />
          </div>
        )}
        {(advtInfo.label || advtInfo.number || advtInfo.socials) && (
          <div className={styles.right}>
            <div className={styles.title}>{advtInfo.label}</div>
            <div className={styles.desc}>
              {advtInfo.socials &&
                advtInfo.socials.map((item) => (
                  <div key={item} className={styles.icon}>
                    {iconsSourcesSvg[item]}
                  </div>
                ))}
              <div className={styles.number}>{advtInfo.number}</div>
            </div>
          </div>
        )}
        <span className={styles.buble3}></span>
        <span className={styles.buble4}></span>
        <span className={styles.buble5}></span>
      </div>
      <span className={styles.buble1}></span>
      <span className={styles.buble2}></span>
    </div>
  );
});

export default Advt;
